import { loadable } from '../../common/utils/lazyLoading';
import structure from './structures/menu';
const EdDrivePage = loadable(() => import('./EdDrivePage'));
export default {
    id: 'ed_drive',
    title: 'Ed-drive',
    icon: 'server',
    route: 'ed-drive',
    defaultRoute: 'ed-drive/my-drive',
    group: 'administration',
    hasDynamicDefaultRoute: true,
    component: EdDrivePage,
    isPermissionCheckSkipped: false,
    panelExtensions: [],
    structure,
};
